export const PERMISSION_TOOLTIP = {
  CONTAINER: 'permission-tooltip-container',
  ICON: 'permission-tooltip-icon'
} as const;
